import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

import { Button } from '@paysense-india-services/elevate-web'

import CardList from '@/components/CardList/index'
import EmiCard from '@/components/EmiCard/index'
import Section from '@/components/Section/index'

/**
 * Maps API response items to CardList format
 * @param {Array} apiItems - Items from API response
 * @returns {Array} Mapped items for CardList
 */
const mapApiItemsToCardList = apiItems => {
  if (!apiItems || !Array.isArray(apiItems)) {
    return []
  }

  return apiItems.map((item, index) => ({
    id: item.id || `emi-${index}`,
    loanAmount: item.title || '',
    emiDetails: item.subtitle || '',
    status: item.meta?.label || null,
    statusColor: item.meta?.color || null,
    route: item.actions?.default?.url || null,
    showArrow: !!item.assets?.trailingIcon || true,
    leadingIcon: item.assets?.leadingIcon || null
  }))
}

const EmiCardList = ({ data }) => {
  const navigate = useNavigate()

  const mappedItems = useMemo(() => {
    return mapApiItemsToCardList(data?.components?.items)
  }, [data?.components?.items])

  const handleItemClick = item => {
    const { route } = item
    if (item.route) {
      const loanId = route.split('/')?.slice(-1)[0]
      navigate(`/loan-detail?loanId=${loanId}`)
    }
  }

  const handleSeeAllClick = () => {
    if (data?.actions?.primary?.url) {
      navigate(data.actions.primary.url)
    }
  }

  const renderItem = item => {
    return <EmiCard item={item} onClick={handleItemClick} />
  }

  return (
    <Section
      rightAction={
        data?.actions?.primary?.text ? (
          <Button
            className='ew-color-brand ew-p-0'
            onClick={handleSeeAllClick}
            size='small'
            variant='link'>
            {data.actions.primary.text}
          </Button>
        ) : null
      }
      title={data?.title}>
      <CardList items={mappedItems} onItemClick={handleItemClick} renderItem={renderItem} />
    </Section>
  )
}

export default EmiCardList
